export default __webpack_public_path__ + "static/media/mesial-okklusal.b062963d.png";